import { render, staticRenderFns } from "./cards-new.vue?vue&type=template&id=7d2edc1c&scoped=true"
import script from "./cards-new.vue?vue&type=script&lang=js"
export * from "./cards-new.vue?vue&type=script&lang=js"
import style0 from "./cards-new.vue?vue&type=style&index=0&id=7d2edc1c&prod&lang=css"
import style1 from "./cards-new.vue?vue&type=style&index=1&id=7d2edc1c&prod&scoped=true&lang=css"
import style2 from "./cards-new.vue?vue&type=style&index=2&id=7d2edc1c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d2edc1c",
  null
  
)

export default component.exports